import InternalInput from './input';
import InputNumber from './number';
import Password from './password';
const Input = InternalInput;
Input.Password = Password;
Input.Number = InputNumber;
export { Input };
